/**
 * Query params used to carry the "signed out for inactivity" reason from the
 * idle-logout redirect (`perform-idle-logout.ts`) to the sign-in page
 * (`SignInView.tsx`). Kept in their own module, with no other imports, so
 * both sides can depend on it without SignInView pulling in the idle-logout
 * flow's `appRouter`/Firebase imports.
 */
export const IDLE_LOGOUT_REASON_PARAM = "reason";
export const IDLE_LOGOUT_REASON_VALUE = "idle-timeout";
export const IDLE_LOGOUT_MINUTES_PARAM = "minutes";
